module.exports = __webpack_public_path__ + "img/art-13.0092efdb.png";